import { createFileRoute, Outlet } from '@tanstack/react-router';

// The URL is /factory-routes (not /routes) purely to avoid clashing with the
// file-based routing directory itself.
export const Route = createFileRoute('/factory-routes')({
  staticData: { section: 'Settings', breadcrumb: 'Routes' },
  component: () => <Outlet />,
});
